import { render, staticRenderFns } from "./ORDER_GET.vue?vue&type=template&id=45885570"
import script from "./ORDER_GET.vue?vue&type=script&lang=js"
export * from "./ORDER_GET.vue?vue&type=script&lang=js"
import style0 from "./ORDER_GET.vue?vue&type=style&index=0&id=45885570&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports